import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  TrackLinkDirective,
  TrackImpressionDirective,
} from '@analytics/events';

import { SegmentedControlEntry } from './segmented-control.model';

@Component({
  selector: 'wl-segmented-control',
  templateUrl: './segmented-control.component.html',
  styleUrls: [
    './segmented-control.component.essent.scss',
    './segmented-control.component.ed.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AutomationIdDirective,
    TrackLinkDirective,
    TrackImpressionDirective,
    FaIconComponent,
  ],
})
export class SegmentedControlComponent<T> {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() entries?: SegmentedControlEntry<T>[];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() selected?: SegmentedControlEntry<T>;

  @Output()
  entrySelected = new EventEmitter<T>();

  clicked(entry: SegmentedControlEntry<T>) {
    this.selected = entry;
    this.entrySelected.emit(entry.value);
  }

  trackById(_: number, entry: SegmentedControlEntry<T>) {
    return entry.id;
  }
}
